import { useEffect, useState , useRef} from "react";
import MDBox from "components/MDBox";
import React from "react";
import { useMaterialUIController, setActivePage } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import DeleteConfirmation from "application/components/DeleteConfirmation";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import { application } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";
import MDButton from "components/MDButton";
import dialog from "assets/theme/components/dialog";
import { Dialog, DialogActions,DialogTitle,} from "@mui/material";
import CTLDialogContent from "application/components/styles/CTLDialogContent";

function ChatMessage({
  onLoad,
  mode,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
  
}) {

  const [controller, dispatch] = useMaterialUIController();
  const { activePage ,  darkMode } = controller;
  const [openFilter, setOpenFilter] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [updateList, setUpdateList] = useState(Date.now());
  const [selectedRows, setSelectedRows] = useState([]);
  const selectedRowsRef = useRef([]);
  const [open, setOpen] = React.useState(false);

const handleClickOpen = () => {
  setOpen(true);
};

const handleClickClose = () => {
  setUpdateList(Date.now());
  setOpen(false);
};

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        onMarkasRead: multipleUpdate,
        onMultipleDelete: multipleDelete,
      });
  }, [activePage]);

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }


  function onApplyFilter(advancedFilters) {
    setAdvancedFilters(advancedFilters);
    setOpenFilter(false);
  }

  const onSelectionChange = (rowId) => {
    setSelectedRows(rowId);
  };

  useEffect(() => {
     selectedRowsRef.current = selectedRows;
   }, [selectedRows]);


  const Update = () => {
     const requestData = { id: selectedRowsRef.current, };
      application
        .post(operationURLS.update, requestData)
        .then((response) => {
          setUpdateList(Date.now());
          setNotify({
            isOpen: true,
            message: response.data.messageDetail,
            type: "success",
            pagename: pageName,
            status: response.data.status,
          });
          setSelectedRows([]);
          selectedRowsRef.current = [];
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.messageDetail,
            type: "error",
            pagename: pageName,
            status: error.response.data.status,
          });
        });
    
  };
  
  const Delete =()=>{
    const requestData = { id: selectedRowsRef.current, };
    application
      .post(operationURLS.delete, requestData)
      .then((response) => {
      setUpdateList(Date.now());  
      setNotify({
        isOpen: true,
        message: response.data.messageDetail,
        type: "success",
        pagename: pageName,
        status: response.data.status,
      });
      setSelectedRows([]);
      selectedRowsRef.current = [];
    })
    .catch((error) => {
      setNotify({
        isOpen: true,
        message: error.response.data.messageDetail,
        type: "error",
        pagename: pageName,
        status: error.response.data.status,
      });
    });
   }

  const multipleUpdate=()=>{
      if (
        selectedRowsRef.current != null &&
        selectedRowsRef.current.length !== 0
      ) {
        Update();
      } else {
        setNotify({
          isOpen: true,
          message: "Error ",
          type: "error",
          pagename: pageName,
          status: "Select at least one Message to update read",
        });
      }
  };

   
   const onAgree = () => {
      Delete();
     setOpen(false);
   };

   const multipleDelete = ()=>{
      if (
        selectedRowsRef.current != null &&
        selectedRowsRef.current.length !== 0
      ) {
        handleClickOpen();
      } else {
        setNotify({
          isOpen: true,
          message: "Error",
          type: "error",
          pagename: pageName,
          status: "Select at least one Messages to delete",
        });
      }
  };

  const markAsRead = (row) => {
    selectedRowsRef.current = [row.id];
     if (row.isMessageRead == false) {
       Update();
     } else {
       setNotify({
         isOpen: true,
         message: "Error  ",
         type: "error",
         pagename: pageName,
         status: "Already read  ",
       });
     }
  };

  const onDelete = (row) => {
      selectedRowsRef.current = [row.id];
      Delete();
  };
  return (
    <MDBox>
      <DeleteConfirmation
        entityName="Message"
        data={selectedRows}
        columns={getColumns(markAsRead, onDelete)}
      />

      <CTLTable
        onSelectionChange={onSelectionChange}
        apiURL={operationURLS.list}
        advancedFilters={advancedFilters}
        columns={getColumns(markAsRead, onDelete)}
        entriesPerPage={false}
        canSearch
        defaultSortDirection="desc"
        defaultSortColumn="recordDate"
        pageId={pageId}
        searchText={searchText}
        hasRowSelection={true}
        updateList={updateList}
        refetchInterval={Attributes.refetchInterval}
      />
      
      <CTLAdvancedFilter
        entityName="Message"
        columns={getColumns(markAsRead, onDelete)}
        applyFilter={openFilter}
        advancedFilters={advancedFilters}
        onApplyFilter={onApplyFilter}
        onCloseFilter={onCloseFilter}
      />

      <Dialog open={open} maxWidth="md" classes={{ dialog }}>
        <DialogTitle
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          id="alert-dialog-title"
        >
          {" "}
          Are you sure you want to delete the selected Messages{" "}
        </DialogTitle>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleClickClose} color="secondary">
            Disagree
          </MDButton>
          <MDButton onClick={onAgree} color="error" autoFocus>
            Agree
          </MDButton>
        </DialogActions>
      </Dialog>

      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default ChatMessage;
